// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ouDl","title":"Info_title__2tonC","links":"Info_links__SeO9I","link":"Info_link__-I3Xp","logo":"Info_logo__1Mi6U"};